import React from 'react';

import { flagStyles } from '../settings';

const SvgAE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-24px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAE;
